import React from 'react';
import { Header } from '../components/global/header';
import { NotFound } from '../components/global/notFound';
import { Footer } from '../components/global/footer';

const NotFoundPage = () => {
  return (
    <div>
      <Header />
      <NotFound />
      <Footer />
    </div>
  );
};

export default NotFoundPage;